import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useAdminLayoutContext } from "../../views/admin/AdminLayoutContext";

const Title = ({ text }: { text: string }) => {
  const { setActiveMenu, setActiveSubItem } = useAdminLayoutContext();
  const handleClick = () => {
    setActiveSubItem("");
    setActiveMenu("");
  };
  return (
    <p className="main-title">
      <Link to="/Admin" onClick={handleClick}>
        <FontAwesomeIcon icon={faCircleArrowLeft} />
      </Link>
      {text}
    </p>
  );
};

export default Title;
